import { useState } from "react";
import { Menu, X, Sparkles, LayoutGrid, Briefcase, PhoneCall, User } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: "Home", path: "/", icon: <LayoutGrid className="w-5 h-5" /> },
    { name: "Services", path: "/services", icon: <Sparkles className="w-5 h-5" /> },
    { name: "Portfolio", path: "/portfolio", icon: <Briefcase className="w-5 h-5" /> },
    { name: "About", path: "/about", icon: <User className="w-5 h-5" /> },
    { name: "Contact", path: "/contact", icon: <PhoneCall className="w-5 h-5" /> },
  ];

  return (
    <header className="bg-white shadow-xl fixed w-full z-50">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        {/* Logo */}
        <motion.div
          whileHover={{ scale: 1.1, rotateY: 5 }}
          className="text-3xl font-bold text-indigo-600 tracking-wide cursor-pointer"
        >
          <Link to="/">
            <span className="text-gray-900">Code</span><span className="text-indigo-600">xa</span>
          </Link>
        </motion.div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-10 items-center text-gray-700 font-semibold">
          {navItems.map((item) => (
            <motion.div
              key={item.name}
              whileHover={{ scale: 1.1 }}
              className={`flex items-center gap-2 transition-all duration-300 cursor-pointer ${
                location.pathname === item.path ? "text-indigo-600" : "hover:text-indigo-600"
              }`}
            >
              {item.icon}
              <Link to={item.path}>{item.name}</Link>
            </motion.div>
          ))}
        </nav>

        {/* Mobile Toggle Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden z-[100] relative text-gray-700"
        >
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Backdrop */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setMenuOpen(false)}
          />
        )}
      </AnimatePresence>

      {/* Mobile Drawer */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "spring", stiffness: 80 }}
            className="md:hidden fixed top-0 right-0 h-full w-3/4 bg-white shadow-2xl z-50"
          >
            <div className="flex flex-col p-6 space-y-6 text-gray-700 text-lg font-medium">
              {navItems.map((item) => (
                <motion.div
                  key={item.name}
                  whileHover={{ scale: 1.05 }}
                  className="flex items-center gap-3 hover:text-indigo-600"
                >
                  {item.icon}
                  <Link
                    to={item.path}
                    onClick={() => setMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                </motion.div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}